import en from '../../../lang/en-us';
import SearchInput from '../../../lib/SearchInput';
import { connect } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { useEffect } from 'react';
import { getTrackStatus, getCommercialTrackStatus } from '../../../redux-store/actions/nct';
import { useState } from 'react';
import moment from 'moment';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import NoFoliosFound from '../makeNct/NoFoliosFound';
import { TableColumn, TableWithCollapse } from '../../../lib/DataTable';
import { useTableWithCollapse } from '../../../lib/DataTable/customHooks';
import { useMemo } from 'react';
import { useCallback } from 'react';
import { FaqLink } from '../makeNct';
import { getDateString, TRACK_STATUS, TRACK_STATUS_TYPES } from '../../../utils/constants';
import SegmentedControl from '../../common/segmented-control';
import TabPanel from '../../common/TabPanel';
import { getQueryParams } from '../../../utils/utilityFunctions';
import { IsAllow } from '../../../redux-store/types/portfolio';

const TRACK_TABS_ID = 'track-status-tabs';

const { dashboard, trackStatus } = en;

export const SUCCESS = 'Success';
export const REJECTED = 'Rejected';
export const INPROGRESS = 'In Progress';
export const COMPLETED = 'Completed';

export const FP = 'First Purchase';
export const AP = 'Additional Purchase';
export const REDEMPTION = 'Redemption';
export const SWITCH = 'SWITCH';

export const getStatus = (value: string) => {
    const uppercaseValue = (value || '').toUpperCase();
    if (uppercaseValue === 'COMPLETED' || uppercaseValue === 'SUCCESS') {
        return COMPLETED;
    }
    if (uppercaseValue === 'PENDING' || uppercaseValue === 'ACCEPTED') {
        return INPROGRESS;
    }
    if (uppercaseValue === 'ERROR' || uppercaseValue === 'ERRORS') {
        return REJECTED;
    }
    return value;
};

function TrackStatus(props: any) {
    const tab = getQueryParams(props.location.search)[0];
    const [trackList, setList] = useState<any>([]);
    const [filterText, setFilterText] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const currentTab = parseInt(tab) !== NaN && [1, 2].includes(parseInt(tab)) ? parseInt(tab) : 1;
    const columns = useCallback(
        (tab): TableColumn[] => {
            const extraColumnsForTransactions: TableColumn[] = [
                {
                    field: 'amcName',
                    headerName: 'Fund house',
                },
                {
                    field: 'folio',
                    headerName: 'Folio',
                },
            ];
            return [
                {
                    field: 'Sno',
                    headerName: 'S NO.',
                    valueGetter: ({ index = 0 }) =>
                        (index + 1).toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false,
                        }),
                },
                ...(currentTab === 2 ? extraColumnsForTransactions : []),
                {
                    field: 'requestTypeDesc',
                    headerName: currentTab === 2 ? 'TRANSACTION TYPE' : 'SERVICE REQUEST TYPE',
                },
                { field: 'reqId', headerName: 'TRANSACTION ID' },
                {
                    field: 'requestTime',
                    headerName: 'DATE',
                    valueGetter: (params) => getDateString(params?.row?.requestTime),
                },
                {
                    field: 'status',
                    headerName: 'STATUS',
                    renderCell: ({ row }) => {
                        const status = getStatus(row.status);
                        return (
                            <div
                                style={{
                                    color: 'white',
                                    padding: 5,
                                    textAlign: 'center',
                                    borderRadius: 10,
                                    background:
                                        status === COMPLETED
                                            ? '#4A785C' // Dark green for WCAG AAA with white text
                                            : status === INPROGRESS
                                            ? '#8C4506' // Dark orange for WCAG AAA with white text
                                            : '#C62828', // Dark red for WCAG AAA with white text
                                }}
                            >
                                {status}
                            </div>
                        );
                    },
                },
                {
                    field: '',
                    headerName: '',
                    renderCell: ({ row }) => {
                        const detailPath = `/portal/${
                            tab === 2 ? 'track-for-transaction' : 'track-for-nct'
                        }/${row.reqId}`;
                        return (
                            <div className="track-view-link">
                                {Boolean(Object.keys(row?.rtaResponse ?? {}).length) && (
                                    <a
                                        href={detailPath}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            props.history.push(detailPath);
                                        }}
                                        aria-label={`View status for ${
                                            row.requestTypeDesc
                                        } request ${row.reqId} ${
                                            row.amcName ? 'at ' + row.amcName : ''
                                        } on ${getDateString(row.requestTime)}`}
                                    >
                                        {' '}
                                        View
                                        <KeyboardArrowRightIcon />
                                    </a>
                                )}
                            </div>
                        );
                    },
                },
            ];
        },
        [currentTab],
    );

    const filteredData = useMemo(() => {
        if (filterText) {
            return trackList.filter((_ele: any) => _ele.reqId.toString().includes(filterText));
        }
        return trackList;
    }, [filterText, trackList]);

    const { tableColumns, tableRows } = useTableWithCollapse({
        rows: filteredData,
        columns: columns(currentTab),
        loading,
    });

    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            try {
                const { pan, pekrn, reqId, mobile } = props;
                let response: any =
                    currentTab === 1
                        ? await props.getTrackStatus({
                              pan,
                              pekrn,
                              mobile,
                          })
                        : await props.getCommercialTrackStatus({
                              pan,
                              pekrn,
                              mobile,
                          });
                const { requests } = response.body;
                setList(
                    requests.map((request: any) => {
                        if (request.requestType === 'NEW_KYC_REGISTER') {
                            return {
                                ...request,
                                status: 'SUCCESS',
                            };
                        }
                        return request;
                    }),
                );
            } catch (e: any) {
                alert(e.message);
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, [currentTab]);

    const TrackSegment = useCallback(
        () => (
            <SegmentedControl
                id={TRACK_TABS_ID}
                ariaLabel="Track requests"
                additionalClasses="portfolio-details-tabs portfolio-demat-tabs track-status-tabs"
                segments={TRACK_STATUS_TYPES}
                selectedSegmentIndex={currentTab - 1}
                onSegmentChanged={(index) => {
                    props.history.replace(`/portal/track?tab=${index + 1}`);
                }}
            />
        ),
        [currentTab],
    );

    const trackPanelIndex = currentTab - 1;

    return (
        <div className="curved-bg">
            {props.ftTransactions === IsAllow.YES ? (
                <TrackSegment />
            ) : (
                <h2 className="heading">
                    <a
                        href="#"
                        aria-hidden="true"
                        tabIndex={-1}
                        style={{
                            visibility: 'hidden',
                        }}
                    >
                        <img src="/images/left-arrow-black.svg" alt="" aria-hidden="true" />
                    </a>
                    {dashboard.dashboardLeft.link4}
                </h2>
            )}
            <TabPanel
                id={`${TRACK_TABS_ID}-tabpanel-${trackPanelIndex}`}
                labelledBy={`${TRACK_TABS_ID}-tab-${trackPanelIndex}`}
                className="curved-bg-content curved-bg-table-outer"
            >
                <div className="curved-bg-content-table">
                    <div style={{ maxWidth: '415px', width: '100%' }}>
                        <SearchInput
                            darkmode={true}
                            placeholder={trackStatus.searchWithTransaction}
                            onChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText}
                        />
                    </div>
                    {useMemo(
                        () => (
                            <div
                                className="curved-table-content"
                                tabIndex={0}
                                aria-label="Track status list"
                            >
                                <div
                                    role="status"
                                    aria-live="polite"
                                    aria-atomic="true"
                                    style={{
                                        position: 'absolute',
                                        left: '-10000px',
                                        width: '1px',
                                        height: '1px',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {filteredData.length}{' '}
                                    {filteredData.length === 1 ? 'result' : 'results'} found
                                </div>
                                {!!tableRows.length || loading ? (
                                    <TableWithCollapse rows={tableRows} columns={tableColumns} />
                                ) : (
                                    <NoFoliosFound info={en.common.noRecordsFound} />
                                )}
                            </div>
                        ),
                        [tableRows, tableColumns],
                    )}
                </div>
                <FaqLink section={TRACK_STATUS} />
                <div className="curved-bg-content-inner-bottom"></div>
            </TabPanel>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getTrackStatus, getCommercialTrackStatus },
)(TrackStatus);
